import { graphql } from 'gatsby';
import React from 'react';
import { ViewportText, ViewportImage } from '../viewport';
import LegacyCTA from '../cta';

type CenteredHeroBlock = {
  settings?: Settings;
  viewport_heading?: ViewportText;
  viewport_title?: ViewportText;
  viewport_text?: ViewportText;
  cta_field?: CtaField;
  viewport_image?: ImageField<ReusableImageField>[];
};

export const CenteredHero: React.FC<{ block: CenteredHeroBlock }> = ({
  block: {
    viewport_heading,
    viewport_title,
    viewport_text,
    cta_field,
    viewport_image: image_template,
  },
}) => {
  const [viewport_image] = image_template ? image_template : [];

  /**
   * .block has to be refactored to a more specific class so it
   * doesn't collide with tailwind classes. At the moment, it's
   * a very generic class that can be found in many places.
   * Hero padding, hard first section rules, etc. that should also be refactored.
   */
  return (
    <section className='block__hero_centered mx-auto block flex w-full max-w-xl flex-col gap-8 bg-cover bg-center bg-no-repeat p-8 xl:max-w-lg lg:max-w-md md:justify-center'>
      <div className='flex h-full flex-col items-center justify-center gap-8 text-center'>
        <ViewportText
          text={viewport_heading}
          as='h1'
          className='text-[2.2rem] leading-none'
        />
        <ViewportText
          text={viewport_title}
          as='h2'
          className='leading-none'
        />
        <ViewportText
          text={viewport_text}
          className='text-[2.4rem] leading-relaxed'
        />
        <LegacyCTA block={cta_field} />
      </div>
      <div className='flex w-full justify-center'>
        <ViewportImage image={viewport_image} />
      </div>
    </section>
  );
};

export const centeredHeroFragment = graphql`
  fragment CenteredHeroFragment on Block {
    settings {
      ...SettingsFragment
    }
    cta_field {
      ...CtaFieldFragment
    }
    viewport_heading {
      ...ViewportTextFragment
    }
    viewport_title {
      ...ViewportTextFragment
    }
    viewport_text {
      ...ViewportTextFragment
    }
    viewport_image {
      ...ImageFieldFragment
    }
  }
`;
